import Navbar from '../Navbar/Navbar';
import { IoMenuOutline, IoCloseOutline } from "react-icons/io5";
import { useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

export default function Header() {
    const [isNavbarOpen, setIsNavbarOpen] = useState(false);

    return (
        <header id='App-header'>
            <div id='App-header-row'>
                <Link id='App-header-logo' to="/">
                    <img src="/kcrmlogo.png" alt="Kansas City Riichi Mahjong" />
                    <p><strong>KC</strong>Riichi</p>
                </Link>
                <span id='menu-icon' onClick={() => setIsNavbarOpen(!isNavbarOpen)}>
                    {isNavbarOpen ? <IoCloseOutline size="1.5em"/> : <IoMenuOutline size="1.5em"/>}
                </span>
            </div>
            <div id="App-header-navbar" className={isNavbarOpen ? "open" : ""}>
                <Navbar onNavigate={() => setIsNavbarOpen(false)} />
            </div>
        </header>
    );
}